import { Grow, IconButton } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { withRouter, useHistory } from "react-router-dom";
import {
  convertedColumnName,
  getEwoFormColumns,
  flattenDataMethod,
} from "../../common";
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getTechnicianList } from "../../store/actions/userActions";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import { getEwoFormsList } from "../../store/actions/EwoActions";
import { getBreakDownReasonGroup } from "../../store/actions/BreakDownListTableActions";
import {
  getRootCauseFamilies,
  getRootCauseFamilyOptions,
} from "../../store/actions/EwoActions";
import * as queryString from "query-string";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { ArrowBackIos } from "@mui/icons-material";

const ssEwo = sessionStorage;

function EwoForms(props) {
  const GetFirstDayOfMonth = () => {
    var dt = new Date(); // current date of week
    return new Date(dt.getFullYear(), dt.getMonth(), 1);
  };

  const GetLastDayOfMonth = () => {
    var curr = new Date(); // get current date
    return new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
  };
  const initialState = {
    breakdownReasonGroupId: 0,
    breakdownReasonGroupName: "",
    startDate:
      sessionStorage.getItem("ewo_startDate") ||
      GetFirstDayOfMonth().toISOString(),
    endDate:
      sessionStorage.getItem("ewo_endDate") ||
      GetLastDayOfMonth().toISOString(),
    interventionDateStart: "",
    interventionDateEnd: "",
    closureDateStart: "",
    closureDateEnd: "",
    rootCauseFamilyName: "",
    rootCauseFamilyOptionName: "",
    rootCauseFamilyId: 0,
    executedTechnicianId: "",
    executedTechnicianName: "",
    verifiedTechnicianId: 0,
    verifiedTechnicianName: "",
  };
  const fromPage = queryString.parse(window.location.search).from;
  const location = useLocation();
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const { ewoForm } = useSelector((state) => state);
  const [rows, setRows] = useState([]);
  const flattenDataArray = [];
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortItem, setSortItem] = useState(null);
  const [rowsLength, setRowsLength] = useState(0);
  const [filterOpen, setFilterOpen] = useState(false);
  const [state, setState] = useState({ ...initialState });
  const { breakDownListTable } = useSelector(
    (breakDownState) => breakDownState
  );
  const [breakdownReasonGroupData, setBreakdownReasonGroupData] = useState([]);

  const [rootCauseFamilyData, setRootCauseFamilyData] = useState([]);

  const [rootCauseFamilyOptionsData, setRootCauseFamilyOptionsData] = useState(
    []
  );

  const [techData, setTechData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const {
    user: { technicianList },
  } = useSelector((user) => user);

  useEffect(() => {
    if (technicianList) {
      setTechData(technicianList);
    }
  }, [technicianList]);

  const setCurrentDate = (date) => {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var modifiedMonth = month <= 9 ? "0" + month : month;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var newStartDate = year + "-" + modifiedMonth + "-" + day;
    return newStartDate;
  };

  const GetFirstDayOfWeek = (date) => {
    var day = date.getDay(),
      diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return moment(date.setDate(diff));
  };

  const GetLastDayOfWeek = (date) => {
    var day = date.getDay(),
      diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return moment(date.setDate(diff + 6));
  };

  let [timeIntervals, setTimeIntervals] = useState([
    { id: 1, name: t("Today") },
    { id: 2, name: t("ThisWeek") },
    { id: 3, name: t("ThisMonth") },
    { id: 4, name: t("Manual") },
  ]);
  let [selectedTimeInterval, setSelectedTimeInterval] = useState(
    ls.get("ewo_interval") || 3
  );

  useEffect(() => {
    dispatch(getRootCauseFamilies());
    dispatch(getBreakDownReasonGroup());
    dispatch(getTechnicianList());
    loadHandler();
  }, []);

  const HandleStartDate = (date) => {
    if (date == null) {
      sessionStorage.removeItem("ewo_startDate");
    } else {
      sessionStorage.setItem(
        "ewo_startDate",
        moment(date).format("YYYY-MM-DD")
      );
    }

    ls.set("ewo_interval", 4);
    setSelectedTimeInterval(4);
    setState({ ...state, startDate: moment(date).format("YYYY-MM-DD") });
  };

  // Set closure date start
  const HandleClosureDateStart = (date) => {
    if (date != null) {
      setState({
        ...state,
        closureDateStart: moment(date).format("YYYY-MM-DD"),
      });
    } else {
      setState({ ...state, closureDateStart: null });
    }
  };

  // Set closure date end
  const HandleClosureDateEnd = (date) => {
    if (date != null) {
      setState({ ...state, closureDateEnd: moment(date).format("YYYY-MM-DD") });
    } else {
      setState({ ...state, closureDateEnd: null });
    }
  };

  // Set closure date
  const HandleInterventionDateStart = (date) => {
    if (date != null) {
      setState({ ...state, interventionDateStart: date });
    } else {
      setState({ ...state, interventionDateStart: null });
    }
  };

  const HandleInterventionDateEnd = (date) => {
    if (date != null) {
      setState({ ...state, interventionDateEnd: date });
    } else {
      setState({ ...state, interventionDateEnd: null });
    }
  };

  // Set end date
  const HandleEndDate = (date) => {
    if (date == null) {
      sessionStorage.removeItem("ewo_endDate");
    } else {
      sessionStorage.setItem("ewo_endDate", moment(date).format("YYYY-MM-DD"));
    }

    ls.set("ewo_interval", 4);
    setSelectedTimeInterval(4);
    setState({ ...state, endDate: moment(date).format("YYYY-MM-DD") });
  };

  const loadHandler = (
    pageNumber = currentPage,
    pageSize = rowsPerPage,
    isFilterCleared = false
  ) => {
    const commonData = {
      breakdownGroupId: isFilterCleared ? 0 : state.breakdownReasonGroupId,
      rootCauseFamilyId: isFilterCleared ? 0 : state.rootCauseFamilyId,
      rootCauseFamilyOptionId: isFilterCleared
        ? 0
        : state.rootCauseFamilyOptionId,
      startDate: state.startDate,
      endDate: state.endDate,
      interventionDateStart: state.interventionDateStart || null,
      interventionDateEnd: state.interventionDateEnd || null,
      verifiedBy: state.verifiedTechnicianId || null,
      analysisExecutedBy: state.executedTechnicianId || null,
      closureDateStart: state.closureDateStart || null,
      closureDateEnd: state.closureDateEnd || null,
    };

    let payload;

    if (fromPage === "breakdownDetail") {
      const data = {
        equipmentId: location.state?.data.equipmentId,
        ...commonData,
      };

      payload = {
        pageSize: pageSize,
        currentPage: pageNumber + 1,
        data: {
          ...data,
          sortItem,
        },
      };
    } else {
      const data = {
        equipmentId: isFilterCleared
          ? 0
          : machineStates.selectedSubEquipmentCode ??
            machineStates.selectedMainEquipmentCode ??
            0,
        ...commonData,
      };

      payload = {
        pageSize: pageSize,
        currentPage: pageNumber + 1,
        data: {
          ...data,
          sortItem,
        },
      };
    }

    console.log("payload", payload);
    dispatch(getEwoFormsList(payload));
  };

  useEffect(() => {
    if (breakDownListTable.reasonGroupData.length) {
      setBreakdownReasonGroupData(
        Object.values(breakDownListTable.reasonGroupData)
      );
    }
  }, [breakDownListTable]);

  useEffect(() => {
    if (ewoForm.rootCauseFamilyOptions.resultObject) {
      setRootCauseFamilyOptionsData(
        ewoForm.rootCauseFamilyOptions.resultObject
      );
    }
  }, [ewoForm.rootCauseFamilyOptions]);

  useEffect(() => {
    if (ewoForm.ewoForms) {
      if (Array.isArray(ewoForm.ewoForms.resultObject?.content)) {
        setIsLoading(false);
        setRows(ewoForm.ewoForms.resultObject.content);
        setRowsLength(ewoForm.ewoForms.resultObject.totalCount);
        setRootCauseFamilyData(ewoForm.rootCauseFamilies.resultObject);
      }
    }
  }, [ewoForm.ewoForms]);
  useEffect(() => {
    setRows([]);
    setIsLoading(true);
  }, [fromPage]);

  const customToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarDensitySelector />
        <GridToolbarColumnsButton name="column" />
      </GridToolbarContainer>
    );
  };

  const NavigateToDetails = (id) => {
    history.push("/create-ewo-form?from=list&id=" + id);
  };

  const handleSort = (columnName) => {
    setSortItem({
      ...sortItem,
      propertyName: convertedColumnName(columnName), //Added to convert column name like "id" to "Id" because of sorting on backend-side
      direction:
        sortItem?.propertyName === convertedColumnName(columnName)
          ? invertSortDirection(sortItem?.direction)
          : 0,
    });
  };

  useEffect(() => {
    if (isMounted.current) loadHandler();
    else isMounted.current = true;
  }, [sortItem]);

  const invertSortDirection = (direction) => (direction === 0 ? 1 : 0);

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(event);
    sessionStorage.setItem("blt_rowsPerPage", event);
    setCurrentPage(0);
    loadHandler(0, event);
  };

  const HandleChangePage = (event) => {
    setRows([]);
    setCurrentPage(event);
    loadHandler(event);
  };

  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsFilterDrawerOpen(open);
  };

  const HandleClearFilter = () => {
    setIsLoading(true);
    HandleClearMachineStates();
    setState({
      startDate: GetFirstDayOfMonth().toISOString(),
      endDate: GetLastDayOfMonth().toISOString(),
      interventionDateStart: null,
      interventionDateEnd: null,
      closureDateStart: null,
      closureDateEnd: null,
      verifiedBy: "",
      analysisExecutedBy: "",
      rootCauseFamilyOptionId: 0,
      rootCauseFamilyName: "",
      breakdownReasonGroupId: 0,
      breakdownReasonGroupName: "",
      rootCauseFamilyId: 0,
      rootCauseFamilyOptionName: "",
      verifiedTechnicianId: 0,
      verifiedTechnicianName: "",
      executedTechnicianId: 0,
      executedTechnicianName: "",
    });
  };

  useEffect(() => {
    // Tüm filtreler sıfırlandığında tekrar yükleme işlemi yapılıyor
    if (isLoading) {
      loadHandler(0, rowsPerPage, true);
      setIsFilterDrawerOpen(false);
    }
  }, [state]); // state değiştiğinde bu effect çalışır

  const HandleApplyFilter = () => {
    setIsLoading(true);
    toggleDrawer(false);
    loadHandler(0, rowsPerPage);
    setIsFilterDrawerOpen(false);
  };

  // Set breakdown reason group
  const HandleEwoBreakdownGroup = (e) => {
    if (e) {
      setState({
        ...state,
        breakdownReasonGroupName: e.breakdownReasonGroupLocalizationName,
        breakdownReasonGroupId: e.id,
      });
    } else {
      setState({
        ...state,
        breakdownReasonGroupName: "",
        breakdownReasonGroupId: 0,
      });
    }
  };

  const HandleVerifiedBy = (e) => {
    if (e) {
      setState({
        ...state,
        verifiedTechnicianId: e.userCode,
        verifiedTechnicianName: e.userName,
      });
    } else {
      setState({
        ...state,
        verifiedTechnicianId: 0,
        verifiedTechnicianName: "",
      });
    }
  };

  const HandleExecutedBy = (e) => {
    if (e) {
      setState({
        ...state,
        executedTechnicianId: e.userCode,
        executedTechnicianName: e.userName,
      });
    } else {
      setState({
        ...state,
        executedTechnicianId: 0,
        executedTechnicianName: "",
      });
    }
  };

  const HandleRootCauseFamilies = (e) => {
    if (e) {
      setState({
        ...state,
        rootCauseFamilyName: e.rootCausesFamilyName,
        rootCauseFamilyId: e.id,
      });
      dispatch(getRootCauseFamilyOptions(e.id));
    } else {
      setState({ ...state, rootCauseFamilyName: "", rootCauseFamilyId: 0 });
    }
  };

  const HandleRootCauseFamilyOptions = (e) => {
    if (e) {
      setState({
        ...state,
        rootCauseFamilyOptionName: e.options,
        rootCauseFamilyOptionId: e.id,
      });
    } else {
      setState({
        ...state,
        rootCauseFamilyOptionName: "",
        rootCauseFamilyOptionId: 0,
      });
    }
  };

  const SetDates = (start, end) => {
    setState((prevState) => ({
      ...prevState,
      startDate: start,
      endDate: end,
    }));
    sessionStorage.setItem("ewo_startDate", start);
    sessionStorage.setItem("ewo_endDate", end);
  };

  const HandleTimeSelection = (id) => {
    switch (id) {
      case 1: //gün
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
      case 2: //hafta
        SetDates(
          GetFirstDayOfWeek(new Date()).toISOString(),
          GetLastDayOfWeek(new Date()).toISOString()
        );
        break;
      case 3: //ay
        SetDates(
          GetFirstDayOfMonth().toISOString(),
          GetLastDayOfMonth().toISOString()
        );
        break;
      default:
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
    }
  };

  const HandleTimeInterval = (e) => {
    setSelectedTimeInterval(e.target.value);
    ls.set("ewo_interval", e.target.value);
    HandleTimeSelection(e.target.value);
    loadHandler(0, rowsPerPage);
  };

  const filter = () => {
    return (
      <DetailFilter
        setMachineStatesEwo={setMachineStates}
        machineStates={machineStates}
        fromPage={fromPage}
        HandleEwoBreakdownGroup={HandleEwoBreakdownGroup}
        breakdownReasonGroupData={breakdownReasonGroupData}
        breakdownReasonGroupName={state.breakdownReasonGroupName}
        HandleRootCauseFamilies={HandleRootCauseFamilies}
        rootCauseFamilyData={rootCauseFamilyData}
        rootCauseFamilyName={state.rootCauseFamilyName}
        HandleRootCauseFamilyOptions={HandleRootCauseFamilyOptions}
        rootCauseFamilyOptionsData={rootCauseFamilyOptionsData}
        rootCauseFamilyOptionName={state.rootCauseFamilyOptionName}
        isDisabledRootCauseFamilyOptions={
          state.rootCauseFamilyId === 0 ? true : false
        }
        techData={techData}
        HandleVerifiedBy={HandleVerifiedBy}
        verifiedTechnicianName={state.verifiedTechnicianName}
        HandleExecutedBy={HandleExecutedBy}
        executedTechnicianName={state.executedTechnicianName}
        HandleStartDate={HandleStartDate}
        HandleEndDate={HandleEndDate}
        startDate={state.startDate}
        endDate={state.endDate}
        maxDate={new Date()}
        HandleInterventionDateStart={HandleInterventionDateStart}
        interventionDateStart={state.interventionDateStart}
        HandleInterventionDateEnd={HandleInterventionDateEnd}
        interventionDateEnd={state.interventionDateEnd}
        HandleClosureDateStart={HandleClosureDateStart}
        closureDateStart={state.closureDateStart}
        HandleClosureDateEnd={HandleClosureDateEnd}
        closureDateEnd={state.closureDateEnd}
        HandleTimeInterval={HandleTimeInterval}
        selectedTimeInterval={selectedTimeInterval}
        timeIntervals={timeIntervals}
      />
    );
  };

  const initialMachineStates = (isCleared = false) => {
    return {
      ssAbr: "blt",
      selectedAreaCode: isCleared
        ? null
        : ssEwo.getItem("ewo_selectedAreaCode") ?? null,
      selectedAreaName: isCleared
        ? null
        : ssEwo.getItem("ewo_selectedAreaName") ?? null,
      selectedMainEquipmentCode: isCleared
        ? null
        : ssEwo.getItem("ewo_selectedMainEquipmentCode") ?? null,
      selectedMainEquipmentName: isCleared
        ? null
        : ssEwo.getItem("ewo_selectedMainEquipmentName") ?? null,
      selectedSubEquipmentCode: isCleared
        ? null
        : ssEwo.getItem("ewo_selectedSubEquipmentCode") ?? null,
      selectedSubEquipmentName: isCleared
        ? null
        : ssEwo.getItem("ewo_selectedSubEquipmentName") ?? null,
    };
  };
  const [machineStates, setMachineStates] = useState(initialMachineStates);
  const HandleClearMachineStates = () => {
    ssEwo.removeItem("ewo_selectedAreaCode");
    ssEwo.removeItem("ewo_selectedAreaName");
    ssEwo.removeItem("ewo_selectedMainEquipmentCode");
    ssEwo.removeItem("ewo_selectedMainEquipmentName");
    ssEwo.removeItem("ewo_selectedSubEquipmentCode");
    ssEwo.removeItem("ewo_selectedSubEquipmentName");
    setMachineStates(initialMachineStates(true));
  };

  const BackToBreakdownDetailListPage = () => {
    props.history.goBack();
  };

  return (
    <StyledTableDiv>
      <h1 id="blt_PageTitle">
        <IconButton
              id="bd_iconBtn"
              style={{ marginBottom: 8, display: "flex" }}
              onClick={BackToBreakdownDetailListPage}
              size="large"
            >
              <ArrowBackIos id="bd_arrowBack" fontSize="inherit" align="end" />
            </IconButton>
        {t("EwoForms") +
          (fromPage === "breakdownDetail"
            ? "(" + location.state?.data.equipmentName + ")"
            : "")}
      </h1>
      <FilterDrawer
        open={isFilterDrawerOpen}
        onOpen={toggleDrawer(true)}
        onClose={toggleDrawer(false)}
        HandleClearFilter={HandleClearFilter}
        HandleApplyFilter={HandleApplyFilter}
        detailFilter={filter()}
      />
      <FilterButton onClick={() => toggleDrawer(true)} />
      {flattenDataArray ? (
        <Grow
          in={true}
          style={{ transformOrigin: "0 0 0" }}
          {...{ timeout: 1000 }}
        >
          <div style={{ width: "100%", textAlign: "center" }}>
            
            {console.log("isloading", isLoading)}
            <DataGrid
              autoHeight={true}
              rows={flattenDataMethod(rows)}
              columns={getEwoFormColumns()}
              pageSize={rowsPerPage}
              onSortModelChange={(sortModel) => handleSort(sortModel)}
              onPageSizeChange={HandleChangeRowsPerPage}
              onPageChange={HandleChangePage}
              rowsPerPageOptions={[5, 10, 20, 50]}
              paginationMode="server"
              rowCount={rowsLength} //total count
              page={currentPage}
              loading={isLoading}
              components={{
                Toolbar: customToolbar,
              }}
              onRowClick={(param) => {
                NavigateToDetails(param.id);
              }}
              sx={{
                boxShadow: 5,
                "& .MuiDataGrid-row:hover": {
                  color: "primary.main",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
              }}
              localeText={{
                toolbarColumns: t("Columns"),
                columnsPanelTextFieldLabel: t("ColumnsPanelTextFieldLabel"),
                columnsPanelTextFieldPlaceholder: t(
                  "ColumnsPanelTextFieldPlaceholder"
                ),
                columnsPanelShowAllButton: t("ColumnsPanelShowAllButton"),
                columnsPanelHideAllButton: t("ColumnsPanelHideAllButton"),
                toolbarDensity: t("Density"),
                toolbarDensityCompact: t("DensityCompact"),
                toolbarDensityStandard: t("DensityStandard"),
                toolbarDensityComfortable: t("DensityComfortable"),
                noResultsOverlayLabel: rows.length === 0 ?? "asdasd",
              }}
            />
          </div>
        </Grow>
      ) : null}
    </StyledTableDiv>
  );
}
export default withRouter(EwoForms);
